export default __webpack_public_path__ + "static/media/hdg-caoting1.c5647ce6.webp";